module.exports = __webpack_public_path__ + "static/assets/9bda5ea0a9a8f88553cc641821f49be3.jpg";